import { useEffect, useState } from "react";
import { useGoToSection } from "../lib/useGo";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  const go = useGoToSection();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink/90 p-3 backdrop-blur-xl lg:hidden" data-testid="sticky-mobile-cta">
      <a
        href="/#contact"
        onClick={go("contact", "sticky_mobile")}
        data-testid="sticky-mobile-cta-btn"
        className="block w-full rounded-full bg-gradient-to-r from-amber-500 to-amber-600 px-6 py-3.5 text-center text-sm font-semibold text-slate-950 shadow-lg shadow-amber-500/25 transition-transform duration-200 active:scale-[0.98]"
      >
        Book a confidential conversation
      </a>
    </div>
  );
};

export default StickyCTA;
